<template>
    <VueFinalModal
        class="flex justify-center items-center"
        content-class="flex flex-col max-w-xl mx-4 p-4 bg-white dark:bg-surface-card rounded-lg space-y-4"
        data-test-id="signInModal"
    >
        <div class="modal-header border-b border-gray-200 dark:border-default pb-4">
            <h2 class="text-xl font-semibold">
                {{ isResetPassword ? 'Zabudnuté heslo' : 'Prihlásenie' }}
            </h2>
        </div>

        <div :key="keyRenderForm" class="w-full">
            <CText v-if="message && !isResetPassword" class="mb-4 block sm:mb-5" variant="muted">
                <span v-html="message"></span>
            </CText>
            <AuthForm
                auth-method="signInWithEmailAndPassword"
                button-label="Prihlásiť sa"
                class="mb-4"
                v-model:loading="isLoading"
                :redirect="route.fullPath"
                v-model:reset-password="isResetPassword"
            />
            <div class="text-center">
                <template v-if="isResetPassword">
                    <CButton href="javascript:void(0)" icon="back" variant="link" @click="goBack()">
                        Späť na prihlásenie
                    </CButton>
                </template>
                <template v-else>
                    Nemáš účet?
                    <NuxtLink class="link" :to="{ name: 'auth-create-account' }"> Registruj sa</NuxtLink>.
                </template>
            </div>
        </div>
    </VueFinalModal>
</template>

<script setup lang="ts">
import AuthForm from '@/components/auth/AuthForm.vue'
import CButton from '@/components/ui/CButton.vue'
import CText from '@/components/ui/CText.vue'
import { useApplicationStore } from '@/stores/application'
import { onMounted, onUnmounted, ref, watch } from 'vue'
import { VueFinalModal } from 'vue-final-modal'
import { useRoute } from 'vue-router'

const props = defineProps({
    message: {
        type: String,
        default: ''
    }
})

const emit = defineEmits(['close'])

const isLoading = ref(false)
const isResetPassword = ref(false)
const keyRenderForm = ref(1)
const route = useRoute()
const userStore = useApplicationStore()
const { $firebase, $auth } = useNuxtApp()

let authStateUnsubscribe: (() => void) | null = null

// Close modal when route changes
watch(
    () => route.path,
    () => {
        emit('close')
    }
)

// Close modal when user gets logged in
watch(
    () => userStore.isLoggedIn,
    (isLoggedIn) => {
        if (isLoggedIn) {
            emit('close')
        }
    }
)

onMounted(async () => {
    // Listen to Firebase auth state changes directly
    if ($firebase && $auth) {
        const { onAuthStateChanged } = await import('firebase/auth')
        authStateUnsubscribe = onAuthStateChanged($auth, (user) => {
            if (user) {
                // User is signed in, close the modal
                emit('close')
            }
        })
    }
})

onUnmounted(() => {
    // Clean up the auth state listener
    if (authStateUnsubscribe) {
        authStateUnsubscribe()
    }
})

const goBack = () => {
    isResetPassword.value = !isResetPassword.value
    keyRenderForm.value += 1
}
</script>
